import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import CurdTokenervice from '../../services/axios/CurdTokenervice'
import { setMessage } from './message'

// Start Quiz
export const startQuizHistory = createAsyncThunk(
    'quizHistory/startQuizHistory',
    async (arg, thunkAPI) => {

        const { rejectWithValue } = thunkAPI
        const { token, data } = arg

        try {
            const res = await CurdTokenervice.startQuizHistory(token, data)
            return res.data
        } catch (error) {
            const message = error.response?.data?.message || error.message
            thunkAPI.dispatch(setMessage(message))
            return rejectWithValue(message)
        }
    }
)

// Update Quiz Progress
export const updateQuizHistory = createAsyncThunk(
    'quizHistory/updateQuizHistory',
    async (arg, thunkAPI) => {

        const { rejectWithValue } = thunkAPI
        const { token, historyId, data } = arg

        try {
            const res = await CurdTokenervice.updateQuizHistory(token, historyId, data)
            return res.data
        } catch (error) {
            const message = error.response?.data?.message || error.message
            thunkAPI.dispatch(setMessage(message))
            return rejectWithValue(message)
        }
    }
)

// Finish Quiz
export const finishQuizHistory = createAsyncThunk(
    'quizHistory/finishQuizHistory',
    async (arg, thunkAPI) => {

        const { rejectWithValue } = thunkAPI
        const { token, historyId } = arg
        try {
            const res = await CurdTokenervice.finishQuizHistory(token, historyId)
            return res.data
        } catch (error) {
            const message = error.response?.data?.message || error.message
            thunkAPI.dispatch(setMessage(message))
            return rejectWithValue(message)
        }
    }
)

// Get Last Quiz History
export const getLastQuizHistory = createAsyncThunk(
    'quizHistory/getLastQuizHistory',
    async (arg, thunkAPI) => {

        const { rejectWithValue } = thunkAPI
        const { token, stdCode, termId, subjectId } = arg

        try {
            const res = await CurdTokenervice.getLastQuizHistory(
                token,
                stdCode,
                termId,
                subjectId
            )

            return res.data

        } catch (error) {

            const message =
                error.response?.data?.message || error.message

            thunkAPI.dispatch(setMessage(message))

            return rejectWithValue(message)
        }
    }
)

const initialState = {
    isloading: false,
    historyId: null,
    attemptNo: null,
    lastHistory: null,
    message: ''
}

const quizHistorySlice = createSlice({
    name: 'quizHistory',
    initialState,

    reducers: {
        clearQuizHistory(state) {
            state.historyId = null
            state.attemptNo = null
            state.lastHistory = null
            state.message = ''
        }
    },
    extraReducers: (builder) => {
        builder
            // Start Quiz
            .addCase(startQuizHistory.pending, (state) => {
                state.isloading = true
                state.message = ''
            })
            .addCase(startQuizHistory.fulfilled, (state, action) => {
                state.isloading = false
                state.historyId = action.payload.Id
                state.attemptNo = action.payload.Attempt_No
                state.message = ''
            })
            .addCase(startQuizHistory.rejected, (state, action) => {
                state.isloading = false
                state.message = action.payload
            })

            // Update Quiz
            .addCase(updateQuizHistory.pending, (state) => {
                state.isloading = true
                state.message = ''
            })
            .addCase(updateQuizHistory.fulfilled, (state) => {
                state.isloading = false
            })
            .addCase(updateQuizHistory.rejected, (state, action) => {
                state.isloading = false
                state.message = action.payload
            })
            // Finish Quiz
            .addCase(finishQuizHistory.pending, (state) => {
                state.isloading = true
            })
            .addCase(finishQuizHistory.fulfilled, (state) => {
                state.isloading = false
                state.historyId = null
                state.attemptNo = null
                state.message = ''
            })
            .addCase(finishQuizHistory.rejected, (state, action) => {
                state.isloading = false
                state.message = action.payload
            })
            // Get Last Quiz History
            .addCase(getLastQuizHistory.pending, (state) => {
                state.isloading = true
                state.message = ''
            })
            .addCase(getLastQuizHistory.fulfilled, (state, action) => {
                state.isloading = false
                state.lastHistory = action.payload
            })
            .addCase(getLastQuizHistory.rejected, (state, action) => {
                state.isloading = false
                state.message = action.payload
            })
    }
})

export const { clearQuizHistory } = quizHistorySlice.actions

export default quizHistorySlice.reducer